module.exports = __webpack_public_path__ + "img/flinder_station_3.63560ced.jpg";